module.exports = __webpack_public_path__ + "img/酒森潔先生_50_50.0f425c4f.png";